import { picobel } from "../Picobel";

export default picobel;
